module.exports = __webpack_public_path__ + "fonts/roboto-v30-latin-500.e65e346.ttf";